// src/services/api/ConfiguracionFacturasApi.ts
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4020';
interface ConfiguracionFactura {
    Id: number;
    NumeroInicial: number;
    NumeroFin: number;
    NumeroActual: number;
    FacturasDisponibles: number;
  }
  
  export class ConfiguracionFacturasApi {
    static async obtenerConfiguracion(): Promise<ConfiguracionFactura> {
      try {
        const response = await axios.post(`${API_URL}/configuracion-facturas/obtener`);
        return response.data.data;
      } catch (error) {
        throw new Error('Error al obtener configuración de facturas');
      }
    }
  }